module.exports = __webpack_public_path__ + "static/media/videosWatched.29f4fc86.png";